// component
import { useParams } from 'react-router-dom';
import Iconify from '../../components/Iconify';
import LucideIcon from '../../components/LucideIcon';

// ----------------------------------------------------------------------

const navConfigMetrics = [
  {
    title: 'Vue globale',
    path: '/analyse/overview',
    icon: 'LayoutDashboard',
  },
  {
    title: 'Audience',
    path: '/analyse/audience',
    icon: 'Users',
  },
  {
    title: 'Événements',
    icon: 'CalendarDays',
    children: [
      {
        title: 'Performance globale',
        path: '/analyse/events',
      },
      {
        title: 'Détails événement',
        path: '/analyse/events/detail',
      },
    ],
  },
  {
    title: 'Revenus',
    path: '/analyse/revenue',
    icon: 'CreditCard',
  },
  {
    title: 'Marketing',
    path: '/analyse/marketings',
    icon: 'Megaphone',
  },
  {
    title: 'Fidélité',
    path: '/analyse/retention',
    icon: 'Heart',
  },
  {
    title: 'Insights IA',
    path: '/analyse/insights',
    icon: 'Sparkles',
    highlight: true,
  },
];


export default navConfigMetrics;
